<script lang="ts" setup>
const { t: $t } = useI18n()

import type { ApiMachineryPublicBaseSelect } from '~/layers/customer-module/types'

defineProps<{ machinery?: ApiMachineryPublicBaseSelect | null, isLoading?: boolean }>()

const machineryPublicDimensions = computed((): OneDataColumn<ApiMachineryPublicBaseSelect>[] => [
  {
    title: $t('customerModule.machinery.details.machinery.tires.type'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => {
      const tireTypeRelations = receptionMachinery?.tire?.receptionMachineryTireTireTypeRelation?.receptionMachineryTireTypes ?? []
      if (tireTypeRelations.length > 0) {
        return tireTypeRelations.map(type => type.typeName).join(', ')
      }
      return receptionMachinery?.tire?.typeName
    },
  },
  {
    title: $t('machinery.tireColor.label'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.tire?.color,
  },
  {
    title: $t('customerModule.machinery.details.machinery.frontSize'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.tire?.frontSize,
  },
  {
    title: $t('customerModule.machinery.details.machinery.rearSize'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.tire?.rearSize,
  },
])
</script>

<template>
  <CustomerModuleDataCard :title="$t('customerModule.machinery.details.machinery.tires.title')" :is-loading="isLoading">
    <template #headerExtra>
      <slot name="headerExtra" />
    </template>
    <TableOneDataColumn :config="{ data: machinery, columns: machineryPublicDimensions }" class="text-base" />
  </CustomerModuleDataCard>
</template>
